import { IAPICodeDTO, IContinuousRoute, IFilterProfile } from '$/types'
import ExpandableItemsList from 'common/components/ExpandableItemsList'
import OverlayScrollbar from 'common/components/OverlayScrollBar'
import { formatWithCommasOrExponential } from 'common/utils/chart/chartUtils'
import { IStateAssessment } from 'features/RiskManagement/Assessments'
import { ILocalFilter } from 'features/RiskManagement/Components/LocalFilter'

interface IScopeInfo {
  localFilterProfile?: ILocalFilter
  globalFilterProfile?: IFilterProfile
  titleClass?: string
  gridClass?: string
  fieldClass?: string
  valueClass?: string
  isWISInfoModal?: boolean
  rerunScenarioInfo?: IStateAssessment
  showScroll?: boolean
}

const ScopeInfo = ({
  globalFilterProfile,
  localFilterProfile,
  titleClass,
  gridClass,
  fieldClass,
  valueClass,
  isWISInfoModal,
  rerunScenarioInfo,
  showScroll = true
}: IScopeInfo) => {
  const segments = rerunScenarioInfo
    ? rerunScenarioInfo.assessmentContinuousRoutes
    : (localFilterProfile?.segments ?? [])

  const classLocation = rerunScenarioInfo
    ? rerunScenarioInfo.assessmentClassLocations
    : (localFilterProfile?.classLocations ?? [])

  const hcamca = rerunScenarioInfo
    ? rerunScenarioInfo.assessmentConsequenceLevels
    : (localFilterProfile?.hmca ?? [])

  const riskLevel = rerunScenarioInfo
    ? rerunScenarioInfo.assessmentRiskLevels
    : (localFilterProfile?.riskLevels ?? [])

  const lines = globalFilterProfile?.continuousRoutes ?? []

  const units = ' ft'

  const parseSegments = (segments: IContinuousRoute[]): Array<string> =>
    segments.map(
      (seg) =>
        (seg.name || String(seg.continuousRouteId)) +
        ': ' +
        formatWithCommasOrExponential(seg.fromMeasure, {isMeasure: true, isGraph: true}) +
        units +
        ' - ' +
        formatWithCommasOrExponential(seg.toMeasure, {isMeasure: true, isGraph: true}) +
        units
    )

  return (
    <>
      <div className={titleClass}>
        <span className='h- uppercase'>Scope</span>
      </div>
      <OverlayScrollbar
        overflow={showScroll ? { y: 'scroll' } : { x: 'hidden' }}
      >
        <div className='pb-6 h-72'>
          <div className={gridClass}>
            <div className={fieldClass}>Routes</div>
            <div className={valueClass}>
              {
                // Show selected Global Filters lines if Local Filter Line Selection is not done
                // Ex. "Line_Name: 100m-1000m and 2 more"
              }
              {lines.length < 1 && !isWISInfoModal ? (
                'Global Scope is not Selected'
              ) : (
                <ExpandableItemsList
                  listItems={parseSegments(segments.length ? segments : lines)}
                  limitToShow={5}
                />
              )}
            </div>

            <hr className='col-span-2 my-2 mr-3' />
            {
              // Show other localfilter properties if selected
            }
            <div className={fieldClass}>HCA/MCA</div>
            <div className={valueClass}>
              {hcamca.map((classification: IAPICodeDTO, index: number) => {
                return (
                  `${classification.name}` +
                  (index + 1 === hcamca.length ? '' : ', ')
                )
              })}
            </div>
            <hr className='col-span-2 my-2 mr-3' />
            <div className={fieldClass}>Class Location</div>
            <div className={valueClass}>
              {classLocation.map((location: IAPICodeDTO, index: number) => {
                return (
                  `${location.name}` +
                  (index + 1 === classLocation.length ? '' : ', ')
                )
              })}
            </div>
            <hr className='col-span-2 my-2 mr-3' />
            <div className={fieldClass}>Risk Level</div>
            <div className={valueClass}>
              {riskLevel.map((risk: IAPICodeDTO, index: number) => {
                return (
                  `${risk.name}` + (index + 1 === riskLevel.length ? '' : ', ')
                )
              })}
            </div>
            <hr className='col-span-2 my-2 mr-3' />
          </div>
        </div>
      </OverlayScrollbar>
    </>
  )
}

export default ScopeInfo
